import jsCookie from 'js-cookie';

const getCookie = (name) => jsCookie.get(name);

const setCookie = (name, value, expiry = 365, secure = document.location.protocol.indexOf('https') !== -1, domain, path = '/', sameSite = 'lax') => {
    const attributes = { expires: expiry, path, secure, sameSite };

    // If we are on localhost and we set a domain, the cookie will not be set.
    jsCookie.set(name, value, domain ? { ...attributes, domain } : attributes);
};

const removeCookie = (name, path = '/', domain) => {
    jsCookie.remove(name, { path, domain });
};

export { getCookie, removeCookie };
export default setCookie;
